import React, { useState, useEffect } from "react";
import styles from "./TagsInput.module.css";
import i18n from "../../Services/i18n";

const TagsInput = ({ value, onChange }) => {
  const [tags, setTags] = useState(value);

  useEffect(() => {
    setTags(value);
  }, [value]);

  const handleInputChange = (e) => {
    const input = e.target.value;

    input
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9-]/g, "")
      .replace(/-{2,}/g, "-");

    setTags(input);
    onChange(input);
  };

  const handleKeyDown = (e) => {
    const key = e.key;
    if (tags && tags.split(";").length >= 10 && key === ";") {
      e.preventDefault();
      return;
    }

    const regex = /^[a-zA-Z0-9-;]$/;
    if (
      !regex.test(key) &&
      key !== "Backspace" &&
      key !== "Tab" &&
      key !== "Enter" &&
      key !== "ArrowLeft" &&
      key !== "ArrowRight" &&
      key !== "Delete"
    ) {
      e.preventDefault();
    }

    const input = e.target.value;
    if (key === ";" && input.endsWith(";")) {
      e.preventDefault();
    }

    if (key === "-" && input.endsWith("-")) {
      e.preventDefault();
    }
  };

  return (
    <div className={styles.tagInputContainer}>
      <textarea
        rows="3"
        placeholder={i18n.t("Taginput.PlaceHolder")}
        value={tags}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        className={styles.tagInput}
      />
      <div className={styles.tagContainer}>
        {tags &&
          tags.split(";").map((tag, index) => (
            <span key={index} className={styles.tag}>
              {tag}
            </span>
          ))}
      </div>
    </div>
  );
};

export default TagsInput;
